import Repository from '../axios'
import {defaultPagination} from "@/constants/config";
const resource = "/admin/report";

export default {
  createChart(payload) {
    return Repository.post(`${resource}/report-analytics`, payload)
  },
  updateChart(id, payload) {
    return Repository.put(`${resource}/report-analytics/${id}`, payload)
  },
  deleteChart(id) {
    return Repository.delete(`${resource}/report-analytics/${id}`)
  },
  getAllCharts() {
    return Repository.get(`${resource}/report-analytics`)
  },
  salesRevenueChartData(from, to, interval = 'monthly', country = '', customer_id = '') {
    return Repository.get(`${resource}/sales-revenue?from=${from}&to=${to}&interval=${interval}&filter[country]=${country}&filter[customer_id]=${customer_id}`)
  },
  getChartData(end_point, from, to, interval = 'monthly', filterQuery) {
    return Repository.get(`${resource}/${end_point}?from=${from}&to=${to}&interval=${interval}&${filterQuery}`)
  },
  getListOfChartManage() {
    return Repository.get(`${resource}/manages`)
  },
  updateChartManage(id, payload) {
    return Repository.put(`${resource}/manages/${id}`, payload)
  },
  downloadReportDocument(end_point, params){
    return Repository.get(`admin/export/report/${end_point}?${params}`, {responseType:'blob'})
  },
  downloadSalesReportDocument(end_point, params){
    return Repository.get(`admin/export/report/${end_point}?${params}`, {responseType:'blob'})
  },
  downloadRawMaterialBatchConsumptionDocument(params){
    return Repository.get(`admin/export/report/consumption-report/raw-material-batch-usage?${params}`, {responseType:'blob'})
  },
  getTraceabilityData(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/tracebility-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  downloadTraceabilityReport(wo_id){
    return Repository.get(`admin/export/report/tracebility-report?work_order_id=${wo_id}`, {responseType:'blob'})
  },
  getMassBalanceData(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw-material-mass-balance-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getMassBalanceDataV2(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw-material-mass-balance-report-v2?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getMassBalanceWorkOrderData(inventory_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw-material-inventory/${inventory_id}/work-order-details?paginate=${pagination}&page=${pageNumber}`)
  },
  getMassBalanceWasteData(inventory_id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw-material-inventory/${inventory_id}/waste-details?paginate=${pagination}&page=${pageNumber}`)
  },
  getOutstandingOrderData(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/outstanding-order-items?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getSundryMassBalanceData(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry-mass-balance-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  downloadExcelSheetData(end_point, filters = '') {
    return Repository.get(`/admin/export/${end_point}?${filters}`, {responseType:'blob'})
  },
  getSupplierAccreditationReport(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/supplier-site-accreditation?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getSalesOrderInvoiceTotal(date, currency) {
    return Repository.get(`${resource}/sales-order-invoice-total?date=${date}&currency=${currency}`)
  },
  getProjectBriefCompletionRate(from, to) {
    const params = new URLSearchParams()
    if (from) params.append('from', from)
    if (to) params.append('to', to)
    const query = params.toString()
    return Repository.get(`${resource}/project-brief-completion-rate${query ? '?' + query : ''}`)
  },
  getOtifMissedItems(pageNumber = 1, filters = {}, pagination = 15) {
    const params = {
      paginate: pagination,
      page: pageNumber,
      ...(typeof filters === 'object' ? filters : { month_year: filters })
    }
    return Repository.request({
      method: 'GET',
      url: `${resource}/otif-missed-items`,
      params,
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  updateOtifRemarks(productOrderItemId, payload) {
    return Repository.put(`${resource}/otif-missed-items/${productOrderItemId}/otif-remarks`, payload)
  },
  sendSupplierAccreditationEmail(id, payload) {
    return Repository.post(`/admin/supplier/saq/${id}/send-reminder`, payload)
  }
};
